import axios from "axios";
import apiClient from "./api.client.service";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";

// Plain axios instance – NO interceptors, NO auth headers
const publicScreeningClient = axios.create({
  baseURL: apiBaseUrl,
  timeout: 60000 * 5, // adjust if you expect longer processing
});

export interface PublicScreeningRequest {
  jobDescription: string;
  resumeFile: File;
  captchaToken: string;
}

export interface PublicScreeningResponse {
  session_id: string;
  report: any; // you can type this from API_CONTRACT.md later
}

/**
 * POST /api/public/screening
 * Content-Type: multipart/form-data
 */
export async function submitPublicScreening(
  payload: PublicScreeningRequest
): Promise<PublicScreeningResponse> {
  const { jobDescription, resumeFile, captchaToken } = payload;

  const formData = new FormData();
  formData.append("job_description", jobDescription);
  formData.append("resume", resumeFile);
  formData.append("captcha_token", captchaToken);

  const response = await publicScreeningClient.post(
    "/api/public/screening",
    formData
    // DO NOT set Content-Type header - let axios/browser set it automatically with boundary
  );

  return response.data as PublicScreeningResponse;
}

export interface RateLimitNotifyRequest {
  email: string;
}

export interface RateLimitNotifyResponse {
  message: string;
}

/**
 * POST /api/public/screening/rate-limit-notify
 * Content-Type: application/json
 * Registers an email address to be notified when the rate limit resets
 */
export async function notifyOnRateLimitReset(
  email: string
): Promise<RateLimitNotifyResponse> {
  const response = await publicScreeningClient.post(
    "/api/public/screening/rate-limit-notify",
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data as RateLimitNotifyResponse;
}

export interface InitiateJobPostResponse {
  job_post_id: string;
}

